import React, { useEffect, useState } from "react";

import ArrowDown from "images/arrow-down.png";

import Document from "images/document.png";
import Community from "images/community.png";
import Horse from "images/horse.png";
import Money from "images/money.png";
import Message from "images/message.png";
import Batch from "images/batch.png";

const metaData = [
  {
    title: "A share of prize money",
    name: "share",
    icon: Document,
  },
  {
    title: "Nothing extra to pay",
    name: "extra_pay",
    icon: Community,
  },
  {
    title: "Stable visits & Raceday Experiences",
    name: "stable_visits",
    icon: Message,
  },
  {
    title: "Weekly updates",
    name: "updates",
    icon: Money,
  },
  {
    title: "Access to our community",
    name: "community",
    icon: Horse,
  },
  {
    title: "Deals and Old Gold Racing Events",
    name: "deals_events",
    icon: Batch,
  },
];

const mergeData = (metaData, data) => {
  const mergedData = metaData?.map((obj) => {
    return {
      ...obj,
      desc: data[obj.name],
    };
  });
  return mergedData;
};

const Benefits = ({ data }) => {
  const [firstColData, setFirstColData] = useState();
  const [secondColData, setSecondColData] = useState();
  const { title } = data;

  const [firstCol, setFistCol] = useState();
  const [secondCol, setSecondCol] = useState();

  useEffect(() => {
    if (data) {
      const mergedData = mergeData(metaData, data);
      setFirstColData(mergedData.filter((_, i) => i < 3));
      setSecondColData(mergedData.filter((_, i) => i >= 3));

      if (typeof window !== 'undefined' && window?.location?.pathname?.includes("fittocks-stud")) {
        setFirstColData(prevState => {
          prevState.push({
            title: "Stud Visits",
            name: "stud_visits",
            icon: Horse,
            desc: "For more than forty years, Luca and Sara Cumani have bred horses at Fittocks Stud just outside of new market. The syndicate will organise two visits during the term for members to tour these famous facilities."
          });

          return prevState;
        });
        setSecondColData(prevState => {
          prevState.push({
            title: "Horse Sale Value",
            name: "horse_sale_value",
            icon: Money,
            desc: "Members will receive a share of 20% of the proceeds if the horse is sold during the two-year syndicate period. This is an exclusive benefit that is rare in lease syndicates of this type."
          });

          return prevState;
        });
      }

      setFistCol(mergedData.map(() => false));
      setSecondCol(mergedData.map(() => false));
    }
  }, [data]);

  const toggleShow = (index, col, setCol) => {
    setCol(col.map((state, i) => (i == index ? !state : state)));
  };

  return (
    <div>
      <h2 className="font-display font-bold text-h2 text-green-800 mb-8">
        {title ? title : 'The Benefits'}
      </h2>
      <div className="flex items-start justify-between gap-x-16 sm:block">
        <div className="w-1/2 flex flex-col gap-y-6 sm:w-full">
          {firstColData?.map(({ title, desc, icon }, index) => (
            <BenefitCard
              toggleShow={toggleShow}
              col={firstCol}
              title={title}
              desc={desc}
              index={index}
              setCol={setFistCol}
              icon={icon}
            />
          ))}
        </div>
        <div className="w-1/2 flex flex-col gap-y-6 sm:w-full">
          {secondColData?.map(({ title, desc, icon }, index) => (
            <BenefitCard
              toggleShow={toggleShow}
              col={secondCol}
              title={title}
              desc={desc}
              index={index}
              setCol={setSecondCol}
              icon={icon}
            />
          ))}
        </div>
      </div>
      <div className="line-through" />
    </div>
  );
};

const BenefitCard = ({ toggleShow, col, index, title, desc, icon, setCol }) => {
  return (
    <div
      className={`p-4 border border-gray-300 w-full cursor-pointer ${
        col[index] == true ? "bg-gray-100" : "bg-gray-200"
      }`}
      onClick={() => toggleShow(index, col, setCol)}
      key={index}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-start justify-start">
          <img src={icon} alt="icon logo" className="w-6 h-6 mr-1 mt-0.5" />
          <h3 className="paragraph-lg text-gray-900">{title}</h3>
        </div>
        <img
          src={ArrowDown}
          alt="arrow down"
          className={`w-6 h-6 ${col[index] == true ? "rotate-180" : ""}`}
        />
      </div>
      <div className={`mt-3 ${col[index] == true ? "block" : "hidden"}`}>
        <p className="font-sans text-sm leading-6 text-gray-700 mt-3">{desc}</p>
      </div>
    </div>
  );
};

export default Benefits;
